import React from 'react';
import style from './member-item-styles';
import { withRouter } from 'react-router-dom';
//material
import { Card, CardContent, CardActionArea, Grid, Avatar, withStyles, IconButton, CardActions, CardMedia } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

function MemberItemView (props) {
  const {classes, history, isLoading, member} = props;

  const navigate = (organisationMemberId) =>
    history.push(`show-member/${organisationMemberId}`);

  return (
    <Card className={classes.card}>
      <CardActionArea disableRipple={isLoading} onClick={!props.isLoading ? () => navigate(member.organisationMemberId) : null}>
        {
          isLoading ?
            <Skeleton variant={'rect'} height={215} /> :
            <CardMedia
              title={'Member Image'}
              image={member.photoUrl}
              className={classes.img}/>
        }

        <CardContent className={classes.cardContent}>
          {
            isLoading ?
              <Skeleton height={24}/> :
              <div className={classes.name}>
                {member.name}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} /> :
              <div className={classes.subtitle}>
                {member.companyName}
              </div>
          }

          <div className={classes.pillContainer}>
            {
              !isLoading && member.memberType.highlight &&
                <div className={classes.memberTypePill}>
                  {member.memberType.description}
                </div>
            }
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default withRouter(withStyles(style) (MemberItemView));
